import { f0FormField } from '@factorialco/f0-react'
import { z } from 'zod'

import i18n from 'modules/core/lib/i18n'

export const createGeneralInfoStepSchema = ({
  datesDisabled = false,
}: { datesDisabled?: boolean } = {}) =>
  z.object({
    name: f0FormField(z.string().trim().min(1), {
      label: i18n.t('planning.period_wizard.general_info.name_label'),
      placeholder: i18n.t('planning.period_wizard.general_info.name_placeholder'),
    }),
    startDate: f0FormField(z.date(), {
      label: i18n.t('planning.period_wizard.general_info.start_date_label'),
      row: 'dates',
      disabled: datesDisabled,
    }),
    endDate: f0FormField(z.date(), {
      label: i18n.t('planning.period_wizard.general_info.end_date_label'),
      row: 'dates',
      disabled: datesDisabled,
    }),
  })
